const parseNumberInput = (value: string): number | undefined => parseInt(value, 10) || undefined;

const parseBoolRadio = (value: string): boolean => value === 'true';

const parseIdsArray = (value: string[]): number[] | null => (value && value.length > 0 ? value.map(Number) : null);

export { parseNumberInput, parseBoolRadio, parseIdsArray };
